import { makeStyles } from '@material-ui/core';
import { Height } from '@material-ui/icons';

const useVerifyEmailStyles = makeStyles((theme) => {
const mobileBreakpoint = theme.breakpoints.down("sm");
return {
    header : {
        [mobileBreakpoint]: {
            fontSize: '30px !important',
            width: '100% !important',
            height: 'auto'
          }
    },
    emailText: {
        [mobileBreakpoint]: {
            fontSize: '20px !important',
            height: 'auto',
            width: '100% !important',
          }
    },
    root: {
      display:'flex',
      flexDirection: 'column',
      minHeight: '100vh',
      backgroundImage: 'none !important',
        [mobileBreakpoint]: {
          backgroundImage: 'none !important'
        }
    },
    trapezoidBgVerifyEmail: {
        position: 'relative',
        zIndex: 1,
        "&::before": {
          content: '""',
          background: 'linear-gradient(234deg, #005C82 28.58%, #0B9EDB 99.46%)',
          position: 'absolute',
          top: '0',
          left: '0',
          width: '100%',
          height: '100%',
          clipPath: 'polygon(95% 0, 100% 0, 100% 100%, 37.5% 100%)'
        }
    },  
      link: {
        color: '#007DB8',
        textDecoration: 'none',
        fontFamily: 'Roboto, sans-serif',
        fontWeight: 500,
        fontSize: '24px',
        lineHeight: '34px',
        width: 'auto',
        height: '34px',
        display: 'inline',
        whiteSpace: 'nowrap', 
              "&:hover": {
            textDecoration: 'underline',
            textDecorationThickness: '2px',
        }
    }
    };
});

export default useVerifyEmailStyles;
